<template>
  <div>
      <template v-if="magicitem.basePrice">
        Grundpreis: {{ magicitem.basePrice }}
      </template>
  </div>
</template>

<script>
export default {
  name:"magicitem",
  props:["test"],
  inject: {
    itemId: {
      default: null,
    },
  },
  methods:
  {
    currentVariation: function ()
    {
      return ceresStore.getters[`${this.itemId}/currentItemVariation`];
    },
    compare: function (a, b)
    {
      if (a.minimumOrderQuantity < b.minimumOrderQuantity)
      {
        return -1;
      }
      if (a.minimumOrderQuantity > b.minimumOrderQuantity)
      {
        return 1;
      }
      return 0;
    },
  },
  computed:
  {
    magicitem: function ()
    {
      let graduatedPrices = JSON.parse(JSON.stringify(this.currentVariation().prices.graduatedPrices));
      let quantity = this.$store.state.items[`${this.itemId}`].variationOrderQuantity;
      let prices = graduatedPrices.sort(this.compare);

      let price = '';
      for (let i = 0; i < prices.length; i++)
      {
        if (prices[i].minimumOrderQuantity <= quantity)
        {
          price = prices[i];
          break; // Beende die Schleife, wenn die Bedingung erfüllt ist
        }
      }
      return price;
    },
  },
};
</script>
